/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnforcementConfigRecord } from './enforcementConfigRecord';


export interface EnforcementConfigResponse { 
    enforcement_config_records?: Array<EnforcementConfigRecord>;
    total_record_count?: number;
}

